import type { ErrorComponentProps } from '@tanstack/react-router';
import { Button, Notice, PageHeader } from '@wodi/ui';

import { ApiError } from '../api/client.ts';
import { errorText, useI18n } from '../i18n/i18n.tsx';

/**
 * Shown in place of a screen that failed to load or stopped working. The error itself
 * is reported by the root's error hooks (main.tsx); this only tells the person what to
 * do. API messages already say what happened and carry the reference to quote.
 */
export function ErrorPage({ error }: ErrorComponentProps) {
  const { t, language } = useI18n();
  const message =
    error instanceof ApiError ? errorText(t, language, error) : t('error.screenStopped');
  return (
    <div style={{ padding: 'var(--space-5)' }}>
      <PageHeader title={t('error.title')} />
      <Notice
        tone="error"
        action={
          <Button
            variant="primary"
            onPress={() => {
              window.location.reload();
            }}
          >
            {t('common.reloadPage')}
          </Button>
        }
      >
        {message}
      </Notice>
    </div>
  );
}
